export default function UploadActions({

    loading = false,

    submitLabel = "Upload File",

    cancelLabel = "Cancel",

    onCancel

}){

    return(

        <div className="upload-actions">

            <button

                type="button"

                className="btn btn-secondary"

                onClick={onCancel}

                disabled={loading}

            >

                {cancelLabel}

            </button>

            <button

                type="submit"

                className="btn btn-primary"

                disabled={loading}

            >

                {

                    loading

                    ? "Uploading..."

                    : submitLabel

                }

            </button>
<style>{`.upload-actions{

    display:flex;

    justify-content:flex-end;

    gap:12px;

    margin-top:28px;

    padding-top:22px;

    border-top:1px solid #E5E7EB;

}

.upload-actions .btn{

    min-width:120px;

    height:44px;

}

@media(max-width:640px){

.upload-actions{

    flex-direction:column-reverse;

}

.upload-actions .btn{

    width:100%;

}

}`}</style>
        </div>

    );

}